module.exports = __webpack_public_path__ + "static/media/transfer-photo@2x.9c4a80e0.png";